import {
  GetJobsQuery,
  GetJobsQueryVariables,
  JobEntity,
} from "@lib/generated/graphql";
import gqlFetch from "./gqlFetch";
import jobsQuery from "./queries/jobsQuery";

const getJobsData = async (params: GetJobsQueryVariables) => {
  const jobsData = await gqlFetch<GetJobsQuery, GetJobsQueryVariables>(
    jobsQuery,
    params,
  );
  return jobsData?.jobs?.data as JobEntity[];
};

export default getJobsData;
